<ng-container *ngIf="done">
<div class="header">
    <h2 mat-dialog-title>{{ "COMISSION.LOG_DIALOG_HEADER" | translate}}</h2>
    <mat-dialog-actions>
        <button mat-icon-button color="primary" mat-dialog-close class="closeButton">
            <mat-icon>close</mat-icon>
        </button>
    </mat-dialog-actions>
</div>
<mat-dialog-content class="content">
    <ng-container *ngIf="done">
        <a>{{ "COMISSION.LOG_DIALOG_TEXT" | translate}}</a>
        <button mat-stroked-button class="back-btn" (click)="backToMenu()">{{ "COMISSION.LOG_DIALOG_BTN" | translate}}</button>
    </ng-container>
</mat-dialog-content>
</ng-container>

<ng-container *ngIf="check">
<div class="header">
    <h2 mat-dialog-title>{{ "COMISSION.EOL_DIALOG_HEADER" | translate}}</h2>
</div>
<mat-dialog-content class="content">
    <a>{{ "COMISSION.EOL_DIALOG_TEXT" | translate}}</a>
</mat-dialog-content>
<mat-dialog-actions class="action">
    <button mat-stroked-button color="primary" (click)="continue()">{{ "COMISSION.EOL_DIALOG_BTN_CONFIRM" | translate }}</button>
    <button mat-stroked-button color="warn" mat-dialog-close cdkFocusInitial>{{ "COMISSION.EOL_DIALOG_BTN_CANCEL" | translate }}</button>
</mat-dialog-actions>
</ng-container>

<ng-container *ngIf="error">
<div class="header">
    <h2 mat-dialog-title>{{ "COMISSION.EOL_DIALOG_ERROR_HEADER" | translate}}</h2>
    <mat-dialog-actions>
        <button mat-icon-button color="primary" mat-dialog-close class="closeButton">
            <mat-icon>close</mat-icon>
        </button>
    </mat-dialog-actions>
</div>
<mat-dialog-content class="content">
    <ng-container *ngIf="error">
        <a>{{ "COMISSION.EOL.ERROR_LOAD" | translate}}</a>
    </ng-container>
</mat-dialog-content>
</ng-container>

<ng-container *ngIf="errorTest">
<div class="header">
    <h2 mat-dialog-title>{{ "COMISSION.EOL_DIALOG_ERROR_HEADER" | translate}}</h2>
    <mat-dialog-actions>
        <button mat-icon-button color="primary" mat-dialog-close class="closeButton">
            <mat-icon>close</mat-icon>
        </button>
    </mat-dialog-actions>
</div>
<mat-dialog-content class="content">
    <ng-container *ngIf="error">
        <a>{{ "COMISSION.EOL.ERROR_DURING" | translate}}</a>
    </ng-container>
</mat-dialog-content>
</ng-container>